import axios from 'axios';

//Internal Request
window.axios = axios;
let token = document.head.querySelector('meta[name="csrf-token"]');

const $api = axios.create({
    withCredentials: true,
});

$api.interceptors.request.use((config) => {
    config.headers['X-IMC-AUTH'] = token.content;
    config.headers['Accept'] = 'application/json';
    return config;
});

$api.CancelToken = axios.CancelToken.source();
window.api = $api;


